import { useState } from "react";
import LOGO_URL from "assets/img/Billbergia-logo.webp";
import toast from "react-hot-toast";
import { useAuthContext } from "context/auth-context";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
    const { signin }= useAuthContext();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await signin(email, password);
            
            // Clear any stored callback URL to prevent unwanted redirects
            localStorage.removeItem('myob_callback_url');
        } catch (error) {
            toast.error("Failed to log in. Please check your email and password.");
            console.error("Login error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md mx-auto">
                <img src={LOGO_URL} alt="Billbergia Logo" className="h-16 mx-auto mb-8" />
                <div className="bg-white rounded-xl shadow-md p-8">
                    <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">Timesheet Login</h1>
                    <form onSubmit={handleLogin} className="space-y-6">
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="Email Address"
                            className="w-full p-3 border rounded-md"
                            required
                        />
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Password"
                            className="w-full p-3 border rounded-md"
                            required
                        />
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                        <button type="submit" disabled={loading} className="w-full p-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300">
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>
                    <div className="text-center mt-4">
                        <Link to="/forgot-password" className="text-sm text-blue-600 hover:underline">
                            Forgot Password?
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;